import React, { useState, useRef } from "react";
import "./UploadFile.css";
import iconCSV from "../../assets/csv.png";
import useSocket, { connectSocket } from "../../utils/useSocket";
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import toast, { Toaster } from "react-hot-toast";
import {
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    RadioGroup, Radio
} from "@heroui/react";
import GenerateSampleFile from "../../utils/GenerateSampleFile";
import { useEffect } from "react";

const UploadFile = ({ leadType, isOpen, onClose, getAllLeads = {}, onUpload, setIsUploadModalOpen, isGenerateSample = true }) => {
    const [file, setFile] = useState(null);
    const [progres, setProgress] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState("");
    const fileInputRef = useRef(null);
    const dropRef = useRef(null);

    const [selectedOption, setSelectedOption] = useState(
        leadType === 'Tvs' ? "manual"
            : "dynamic"
    );
    const [isDualMode, setIsDualMode] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { progress, uploadId } = useSocket();
    const [responseDetails, setResponseDetails] = useState(false);
    const [downloadLink, setDownloadLink] = useState("");
    const [invalidEntries, setInvalidEntries] = useState("");
    const [apiData, setApiData] = useState({});

    const allowedFileTypes = ["text/csv", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];

    useEffect(() => {
        if (leadType === 'Revolt') {
            setIsDualMode(true);
        } else if (leadType === 'Tvs') {
            setIsDualMode(false);
        } else if (leadType === 'Ola') {
            setIsDualMode(true);
        } else if (leadType === 'Ampere') {
            setIsDualMode(true);
        } else {
            setIsDualMode(false);
        }
    }, [leadType])

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            validateAndUpload(file);
        }
    };

    const validateAndUpload = (file) => {
        if (!allowedFileTypes.includes(file.type)) {
            setError("Invalid file type! Please upload a CSV or Excel file.");
            setFile(null);
            return;
        }
        setError("");
        setFile(file);
        startUpload(file);
    };

    const startUpload = (file) => {
        setProgress(0);
        setUploading(true);

        let progressValue = 0;
        const interval = setInterval(() => {
            progressValue += 10;
            setProgress(progressValue);
            if (progressValue >= 100) {
                clearInterval(interval);
                setUploading(false);
            }
        }, 100);
    };


    const handleDragOver = (e) => {
        e.preventDefault();
        dropRef.current.classList.add("dragover");
    };

    const handleDragLeave = () => {
        dropRef.current.classList.remove("dragover");
    };

    const handleDrop = (e) => {
        e.preventDefault();
        dropRef.current.classList.remove("dragover");
        const files = e.dataTransfer.files;
        if (files.length > 0) {
            validateAndUpload(files[0]);
        }
    };

    let updatedLeadType = leadType;
    if (isDualMode && (leadType === 'Revolt')) {
        updatedLeadType = selectedOption === 'dynamic' ? leadType : `${leadType}Manual`;
    } else if (leadType === 'Ola' || leadType === 'Ampere') {
        updatedLeadType = selectedOption === 'manual' ? `${leadType}OnlyImport` : selectedOption === 'forceolasend' ? 'OlaForceImport' : leadType;
    } else {
        updatedLeadType = selectedOption === 'manual' ? `${leadType}Manual` : leadType;
    }

    const handleUpload = async () => {
        if (!file) {
            setError("Please select a file before uploading.");
            return;
        }

        setIsLoading(true);
        connectSocket();

        const formData = new FormData();
        formData.append("excel", file);
        formData.append("uploadId", uploadId);
        formData.append("Company", updatedLeadType);

        try {
            const res = await onUpload(formData, updatedLeadType);
            if (res?.data) {
                if (res.data.result && res.data.count) {
                    setDownloadLink(res.data.result);
                    setApiData(res.data.count);
                    setResponseDetails(true);
                }
                else if (res.data.result) {
                    setDownloadLink(res.data.result);
                    setResponseDetails(false);
                } else if (res.data.count) {
                    setApiData(res.data.count);
                    setResponseDetails(true);
                } else if (res.data.invalidEntries) {
                    setInvalidEntries(res.data.invalidEntries);
                    setResponseDetails(false);
                }
                else {
                    setTimeout(async () => {
                        handleCloseModal();
                        setApiData({});
                    }, 1500);
                }
                setIsLoading(false);
                toast.success(res.data.message);
                setTimeout(async () => {
                    if (leadType !== 'RevoltTvsLeadverification') {
                        let filterType = { page: 1, limit: 10, company: leadType }
                        await getAllLeads(filterType);
                    }
                }, 1500);

            } else {
                toast.error("Unexpected response format.");
            }
        } catch (error) {
            setIsLoading(false);
            setResponseDetails(false);
            setError(error.message);
        }
    };

    const handleCloseModal = async () => {
        setApiData({})
        setUploading(false);
        setProgress(0);
        setFile(null);
        setError("");
        setDownloadLink("");
        setInvalidEntries("");
        setIsLoading(false);
        setResponseDetails(false);
        onClose();
    };

    // Download Leads
    const handleDownload = () => {
        const url = downloadLink || invalidEntries;
        if (url) {
            const link = document.createElement('a');
            link.href = url;
            link.download = leadType === 'RevoltTvsLeadverification' ? `${leadType}-result.xlsx` : downloadLink ? `${leadType}-Accepted-Leads.xlsx` : `${leadType}-Invalid-Leads.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setIsUploadModalOpen(false);

            setDownloadLink(null)
            setInvalidEntries(null)
            handleCloseModal();
            toast.success('File downloaded successfully.');
        } else {
            toast.error('Download URL is not available');
        }
    };

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return (
        <>
            <Modal
                size="lg"
                isDismissable={false}
                isKeyboardDismissDisabled={true}
                isOpen={isOpen}
                // onOpenChange={onOpenChange}
                onClose={handleCloseModal}
            >
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1">
                                <h2 className="text-2xl">{leadType === 'RevoltTvsLeadverification' ? 'Import Revolt & TVS leads For Verification' : `Import ${leadType} Leads`}</h2>
                            </ModalHeader>
                            <ModalBody>
                                {isDualMode && (
                                    <div className="flex gap-5 items-center justify-between">
                                        <p className="font-light text-[16px] text-black">Select Upload Lead Type</p>
                                        <RadioGroup color="success" orientation="horizontal"
                                            value={selectedOption}
                                            onValueChange={(val) => setSelectedOption(val)}
                                        >
                                            <div
                                                className={`border border-gray-100 px-2 py-1 rounded-global flex cursor-pointer transition-colors ${selectedOption === "dynamic" ? "bg-secondary border-secondary" : "bg-white"
                                                    }`}
                                            ><Radio size='sm' className="text-sm" value="dynamic">
                                                    {(leadType === 'Ola' || leadType === 'Ampere') ? "All OEMs" :
                                                        "Dynamic"
                                                    }
                                                </Radio></div>
                                            <div className={`border border-gray-100 px-2 py-1 rounded-global flex cursor-pointer transition-colors ${selectedOption === "manual" ? "bg-secondary border-secondary" : "bg-white"
                                                }`}><Radio size='sm' value="manual" className="text-sm">
                                                    {leadType === 'Ola' ? "Ola Only" :
                                                        leadType === 'Ampere' ? "Ampere Only" :
                                                            "Manual"
                                                    }
                                                </Radio></div>
                                            {leadType === 'Ola' && (
                                                <div className={`border border-gray-100 px-2 py-1 rounded-global flex cursor-pointer transition-colors ${selectedOption === "forceolasend" ? "bg-secondary border-secondary" : "bg-white"
                                                    }`}><Radio size='sm' value="forceolasend" className="text-sm">
                                                        Force Ola Send
                                                    </Radio></div>
                                            )}
                                        </RadioGroup>
                                    </div>
                                )}

                                {!isLoading && responseDetails ? (
                                    <div className='uploadedCsv-details-container flex gap-4 flex-col'>
                                        {apiData && Object.entries(apiData).map(([key, value]) => (
                                            <div key={key} className="response-data-boc p-3 border bg-secondary rounded-lg">
                                                {capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1').trim())} : <b>{value}</b>
                                            </div>
                                        ))}
                                    </div>
                                ) : isLoading ? (
                                    <>
                                        <div className="processing-container">
                                            <div className="processing-text">
                                                Please wait while we are processing
                                                <span>.</span>
                                                <span>.</span>
                                                <span>.</span>
                                            </div>
                                            <div className="processing-dots"></div>
                                        </div>
                                    </>
                                ) : <>
                                    <div
                                        className="file-upload-wrapper"
                                        ref={dropRef}
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                    >
                                        <input
                                            type="file"
                                            id="fileUpload"
                                            ref={fileInputRef}
                                            onChange={handleFileChange}
                                            accept=".csv, .xls, .xlsx"
                                            style={{ display: "none" }}
                                        />
                                        <label htmlFor="fileUpload" className="file-upload-label cursor-pointer">
                                            <span className="file-icon">{file ? <img src={iconCSV} alt="CSV" width={54} height={60} /> : "📁"}</span>
                                            <span className="file-text">
                                                {file ? (
                                                    <p>{file.name} <br /> <span className="text-accepted">{progres > 99 && 'Uploaded successfully!'}</span></p>
                                                ) : (
                                                    "Upload or drag and drop files"
                                                )}
                                            </span>
                                        </label>

                                        {uploading && (
                                            <div id="progress-container">
                                                <div id="progress-bar" style={{ width: `${progres}%` }}></div>
                                            </div>
                                        )}

                                        {error && <p className="error-text text-danger text-sm pt-2 text-center">{error}</p>}
                                    </div>
                                </>}
                            </ModalBody>
                            <ModalFooter className="flex justify-between items-center">
                                {downloadLink || invalidEntries ? (
                                    <button
                                        style={{ backgroundColor: '#fcbf00', color: '#000' }}
                                        className="ladda-button btn px-4 btn-ladda"
                                        onClick={handleDownload}
                                    >
                                        {leadType === 'RevoltTvsLeadverification' ? 'Download Results' : `Download ${leadType} Undelivered Leads`}
                                    </button>
                                ) : isLoading ? (
                                    <>
                                        <Box sx={{ position: 'relative', width: '100%' }}>
                                            <Typography
                                                variant="body2"
                                                sx={{

                                                }}
                                            >
                                                {Math.round(progress)}% done
                                            </Typography>
                                            <LinearProgress color="success" variant="determinate" value={progress} />
                                        </Box>
                                    </>
                                ) : responseDetails && !isLoading && !downloadLink && !invalidEntries ? (
                                    <>
                                        <Button color="danger" variant="flat" onPress={handleCloseModal}>
                                            <p className="text-black">Cancel</p>
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <div className="text-success text-small cursor-pointer hover:text-primary-700">
                                            {isGenerateSample && (<GenerateSampleFile leadType={leadType} />)}
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <Button color="primary" variant="flat" onPress={handleCloseModal}>
                                                <p className="text-primary-900">Cancel</p>
                                            </Button>
                                            <Button color="secondary" onPress={handleUpload}>
                                                <p className="text-black">Confirm</p>
                                            </Button>
                                        </div>
                                    </>
                                )}

                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>
            <Toaster position="top-right" />
        </>
    );
};

export default UploadFile;
